const Footer = () => {
    return (
        <div className="bg-primary p-4 text-white">
            <div className="text-center text-sm">
                All Rights Reserved{" "}
                <span className="font-bold">@Ashish Bansal</span>
            </div>
        </div>
    );
};

export default Footer;
